import { Component, Input, OnInit } from '@angular/core';
import { DownloaderService } from '../../../shared/services/downloader.service';

@Component({
  selector: 'app-downloader',
  templateUrl: './downloader.component.html',
  styleUrls: ['./downloader.component.scss']
})

export class DownloaderComponent implements OnInit {

  @Input() fileType: string;
  @Input() fileName: string;
  @Input() base64Content: string;
  @Input() boutonName: string;

  constructor(private downloaderService: DownloaderService) {
  }

  public ngOnInit() {
    //@ts-ignore
    document.querySelector("#rapport_btn").focus()
  }

  public downloadFile() {
    this.downloaderService.downloadFile(this.fileName, this.base64Content, this.fileType);
  }
}
